module.exports = __webpack_public_path__ + "img/img-banner@2x.592eb333.jpg";